import type { PropsWithChildren } from 'react'
import { Box } from '@vp/swan'
export const SpacingWrapper = (props: PropsWithChildren<unknown>) => {
  return (
    <Box marginTop={2} marginBottom="between-sections">
      {props.children}
    </Box>
  )
}
